import { Component } from 'vue-property-decorator';
import { Button, PaneDropdown, TextInput } from 'streamlabs-beaker';
import EditorBase from './EditorBase';
import Canvas from './Canvas.vue';
import Layer from './Layer.vue';
import Settings from './Settings.vue';
import { IScene } from '@/helpers/editor';
import Editor from './Editor.vue';
import EditorMobile from './EditorMobile.vue';
import ConnectStreamlabsModal from './modals/ConnectStreamlabsModal.vue';
import AvatarDropdown from '@/components/topnav/AvatarDropdown.vue';
import NewsUpdateButton from '@/components/topnav/NewsUpdateButton.vue';
import ProjectApi from '@/apis/project-api';
import NotificationHelper from '@/helpers/notification';
import StreamStatus from '@/components/editor/StreamStatus.vue';
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import { AppsDropdown } from '@streamlabs-core/sl-one-fe-components-vue2';


@Component({
  components: {
    Canvas,
    Layer,
    Settings,
    SButton: Button,
    SPaneDropdown: PaneDropdown,
    ConnectStreamlabsModal,
    AvatarDropdown,
    STextInput: TextInput,
    StreamStatus,
    ConfirmationModal,
    AppsDropdown,
    NewsUpdateButton,
  },
})
export default class EditorPage extends EditorBase {
  editSceneNameMode: boolean = false;
  sceneNameToEdit: string = null;
  isTappedTwice: boolean = false;

  get editorTitle(): string {
    return !this.isMobile ? `${this.projectTitle} <i  ${this.sceneTitle}` : this.sceneTitle;
  }

  get topNavHeightVar() {
    return {
      '--height': '64px',
    };
  }

  get editorComponent() {
    return this.isMobile ? EditorMobile : Editor;
  }

  navigateBack() {
    this.selectedScene = null;
    this.components = [];
    this.webcamStream = null;
    this.editorModule.clearComponentUpdateList();

    if (!this.isMobile) {
      this.selectedProject = null;
      this.$router.push('/projects');
      return;
    }

    this.$router.push(`/projects/${this.$route.params.projectUuid}/scenes`);
  }

  async doubleTapEditSceneName() {
    // listen to double click
    if (!this.isTappedTwice) {
      this.isTappedTwice = true;
      setTimeout(() => {
        this.isTappedTwice = false;
      }, 300);

      return;
    }

    this.setEditSceneNameMode(true);
  }

  setEditSceneNameMode(value: boolean) {
    this.sceneNameToEdit = this.sceneTitle;
    this.editSceneNameMode = value;

    // when editing scene name, offload selectedComponent to prevent keystroke making changes on the component
    if (value) {
      this.selectedComponent = null;
    }
  }

  async saveSceneName() {
    if (!this.sceneNameToEdit.length) {
      return NotificationHelper.error('Scene name is required');
    }

    if (50 < this.sceneNameToEdit.length) {
      return NotificationHelper.error('Maximum character length for scene name 50');
    }

    const response = await ProjectApi.saveProjectScene(
      this.selectedProject.uuid,
      this.selectedScene.uuid,
      {
        title: this.sceneNameToEdit,
      },
    );

    if (response.success) {
      this.selectedScene.title = (response.scene as IScene).title;

      NotificationHelper.success('Scene is saved successfully');
    } else {
      NotificationHelper.error(response.message);
    }

    this.setEditSceneNameMode(false);
  }
}
